import api from './api'
import type { User } from '@/models/User'

export interface LoginCredentials {
    email: string
    password: string
}

export interface RegisterCredentials extends LoginCredentials {
    name: string
}

class AuthService {
    async login(credentials: LoginCredentials): Promise<User | null> {
        try {
            // Récupérer d'abord le token CSRF
            const csrfResponse = await api.get('/users/sign_in.json')
            const csrfToken = csrfResponse.headers['x-csrf-token']

            // Faire la requête de connexion avec le token CSRF
            const response = await api.post('/users/sign_in.json', {
                user: credentials
            }, {
                headers: {
                    'X-CSRF-Token': csrfToken
                }
            })
            localStorage.setItem('user_token', response.data.authentication_token)
            localStorage.setItem('user_email', response.data.email)
            if (response.status === 201) {
                const userData = response.data
                return userData
            }
            return null
        } catch (error) {
            console.error('Erreur de connexion:', error)
            return null
        }
    }

    async register(credentials: RegisterCredentials): Promise<{ user: User | null, errors: any }> {
        try {
            // Récupérer d'abord le token CSRF
            //            const csrfResponse = await api.get('/users.json')
            //            const csrfToken = csrfResponse.headers['x-csrf-token']

            // Faire la requête d'inscription avec le token CSRF
            const response = await api.post('/users.json', {
                user: credentials
            }, {

            })

            if (response.status === 201) {
                const userData = response.data
                return { user: userData, errors: null }
            }
            return { user: null, errors: null }
        } catch (error: any) {
            console.error('Erreur d\'inscription:', error)
            // Capturer les erreurs du serveur
            const errors = error.response?.data?.errors || null
            return { user: null, errors }
        }
    }
    async checkAuth(): Promise<User | null> {
        try {
            const response = await api.get('/users/current.json')
            if (response.status === 200) {
                const userData = response.data

                return userData
            }
            return null
        } catch (error) {
            console.error('Erreur de vérification de l\'authentification:', error)
            return null
        }
    }
    async checkAuthOld(): Promise<boolean> {
        try {
            const response = await api.get('/users/current.json')
            return response.status === 200
        } catch (error) {
            console.error('Erreur de vérification de l\'authentification:', error)
            return false
        }
    }

    logout(): void {
        localStorage.removeItem('user_token')
        localStorage.removeItem('user_email')
    }

    async impersonate(userId: number): Promise<User | null> {
        try {
            const response = await api.post(`/users/${userId}/impersonate.json`)
            if (response.status === 200) {
                return response.data.user
            }
            return null
        } catch (error) {
            console.error('Erreur lors de l\'impersonation:', error)
            return null
        }
    }

    async forgotPassword(email: string): Promise<void> {
        try {
            await api.post('/users/password.json', {
                user: { email }
            })
        } catch (error) {
            console.error('Erreur lors de la demande de réinitialisation:', error)
            throw error
        }
    }

    async resetPassword(token: string, password: string, passwordConfirmation: string): Promise<void> {
        try {
            await api.put('/users/password.json', {
                user: {
                    reset_password_token: token,
                    password: password,
                    password_confirmation: passwordConfirmation
                }
            })
        } catch (error) {
            console.error('Erreur lors de la réinitialisation du mot de passe:', error)
            throw error
        }
    }
}

export const authService = new AuthService() 